module.exports = __webpack_public_path__ + "img/icon_circle_close_black.cc3b0fd2.svg";